module.exports = __webpack_public_path__ + "fonts/montserrat-extralight-webfont.8b39e86.woff";